import { Progress as AntProgressBar } from "antd";
import { themeColors } from "index";
import React from "react";

type ProgressSize = "small" | "default";
type ProgressType = "line" | "circle" | "dashboard";

export type ProgressBarProps = {
  percent: number;
  size: ProgressSize | number | [number, number];
  type?: ProgressType;
};

const ProgressBar: React.FC<ProgressBarProps> = ({
  percent,
  size,
  type = "line",
  ...props
}) => {
  return (
    <AntProgressBar
      {...props}
      percent={percent}
      strokeColor={themeColors.default.primary.main}
      size={size}
      type={type}
    />
  );
};

export default ProgressBar;
